




















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import DeskDto from '@/models/Desks/DeskDto';
import UpdateDeskExternalAccountingSystemSettingsRequest from '@/models/Desks/UpdateDeskExternalAccountingSystemSettingsRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'DeskExternalAccountingEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new DeskDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentDesk));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateDeskExternalAccountingSystemSettingsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.externalAccountingSystemShiftHoursAccount = this.entity.externalAccountingSystemShiftHoursAccount;
    request.externalAccountingSystemTravelHoursAccount = this.entity.externalAccountingSystemTravelHoursAccount;
    request.externalAccountingSystemDistanceAccount = this.entity.externalAccountingSystemDistanceAccount;
    request.externalAccountingSystemPlacementAccount = this.entity.externalAccountingSystemPlacementAccount;
    request.externalAccountingSystemShiftHoursCategory1 = this.entity.externalAccountingSystemShiftHoursCategory1;
    request.externalAccountingSystemTravelHoursCategory1 = this.entity.externalAccountingSystemTravelHoursCategory1;
    request.externalAccountingSystemDistanceCategory1 = this.entity.externalAccountingSystemDistanceCategory1;
    request.externalAccountingSystemPlacementCategory1 = this.entity.externalAccountingSystemPlacementCategory1;
    request.externalAccountingSystemShiftHoursCategory2 = this.entity.externalAccountingSystemShiftHoursCategory2;
    request.externalAccountingSystemTravelHoursCategory2 = this.entity.externalAccountingSystemTravelHoursCategory2;
    request.externalAccountingSystemDistanceCategory2 = this.entity.externalAccountingSystemDistanceCategory2;
    request.externalAccountingSystemPlacementCategory2 = this.entity.externalAccountingSystemPlacementCategory2;

    await AgencySettingsModule.editDeskExternalAccountingSystemSettings(request)
    this.dialog = false;
  }
}
